/* ===========================================================================
   Safer Lighting — affiliate referral capture (cookie + cart attribution).
   • Reads ?ref=CODE from any landing URL, stores it in a 90-day first-party
     cookie + localStorage, and stamps it onto the Shopify cart as the `ref`
     attribute. That attribute rides along into the order's note_attributes, so
     scripts/affiliate-report.cjs can attribute the sale to the affiliate.
   • No third-party scripts, no backend. Pure first-party, privacy-respecting.
   • Last-touch within the 90-day window wins (industry standard).
   =========================================================================== */
(function () {
  const COOKIE = 'sl_ref';
  const DAYS = 90;

  function getParam(name) {
    const m = new RegExp('[?&]' + name + '=([^&#]*)').exec(location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : null;
  }
  function setCookie(v) {
    const d = new Date(); d.setTime(d.getTime() + DAYS * 864e5);
    document.cookie = COOKIE + '=' + encodeURIComponent(v) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie() {
    const m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function clean(v) { return (v || '').trim().toUpperCase().replace(/[^A-Z0-9_-]/g, '').slice(0, 40); }

  // 1) Capture from URL (last-touch wins)
  const fromUrl = clean(getParam('ref'));
  const ref = fromUrl || getCookie();
  if (fromUrl) { setCookie(fromUrl); try { localStorage.setItem(COOKIE, fromUrl); } catch (e) {} }
  if (!ref) return;

  // 2) Stamp the cart so it lands on the order. Only write if it differs, to
  //    avoid needless cart updates on every page view.
  function syncCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const current = (cart.attributes && cart.attributes.ref) || '';
        if (current === ref) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { ref: ref } })
        });
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCart);
  else syncCart();
})();
